import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class SubscriptionsLink extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, subscriptionId }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError(`[SubscriptionsLink][Step][getAll] organizationId and subscriptionId are mandatory`);
        }

        return `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/subscription_links`;
    }
}
